/**
 * @remarks
 * Comparisons are limited to the range [-1, 1] in order to avoid the potential
 * of over-/underflows when comparisons are implemented naively using
 * subtractions, such `a - b`; this would not be allowed.
 *
 * @public
 */
export var Comparison;
(function (Comparison) {
    Comparison[Comparison["Less"] = -1] = "Less";
    Comparison[Comparison["Equal"] = 0] = "Equal";
    Comparison[Comparison["Greater"] = 1] = "Greater";
})(Comparison || (Comparison = {}));
//# sourceMappingURL=comparison.js.map